"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileCard = function FileCard(props) {
  var deleteImage = function deleteImage(e) {
    props.onDelete(e, props.imgId, props.parentId);
  };

  var updateMainImage = function updateMainImage(e) {
    props.onUpdateMainImage(e, props.imgId, props.parentId);
  };

  var preview = '',
      mainImageButton = '';

  if (props.isImage) {
    preview = /*#__PURE__*/_react.default.createElement("div", {
      className: "preview-image"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "preview-image__img"
    }, /*#__PURE__*/_react.default.createElement("picture", null, /*#__PURE__*/_react.default.createElement("source", {
      srcSet: props.largeUrl,
      media: "(min-width: 1024px)"
    }), /*#__PURE__*/_react.default.createElement("source", {
      srcSet: props.mediumUrl,
      media: "(min-width: 700px)"
    }), /*#__PURE__*/_react.default.createElement("img", {
      alt: props.filename,
      srcSet: props.smallUrl
    }))));
  }

  if (props.displayMainImage) {
    mainImageButton = /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
      onClick: updateMainImage,
      className: "file-action"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "icon icon-checkbox-off"
    })));

    if (props.isMainImage) {
      mainImageButton = /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        className: "file-action"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-checkbox-on"
      })));
    }
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "file-card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "file-card__header"
  }, preview), /*#__PURE__*/_react.default.createElement("div", {
    className: "file-card__body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "file-info"
  }, props.filename)), /*#__PURE__*/_react.default.createElement("div", {
    className: "separator"
  }, /*#__PURE__*/_react.default.createElement("hr", null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "file-card__footer"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "file-actions"
  }, mainImageButton, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
    onClick: deleteImage,
    className: "file-action"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "icon icon-delete"
  }))))));
};

FileCard.defaultProps = {
  onDelete: function onDelete() {},
  onUpdateMainImage: function onUpdateMainImage() {},
  isImage: false,
  mainImageId: 0,
  displayMainImage: false
};
FileCard.propTypes = {
  imgId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  largeUrl: _propTypes.default.string,
  mediumUrl: _propTypes.default.string,
  smallUrl: _propTypes.default.string,
  onDelete: _propTypes.default.func,
  parentId: _propTypes.default.number,
  isImage: _propTypes.default.bool,
  filename: _propTypes.default.string,
  isMainImage: _propTypes.default.bool,
  displayMainImage: _propTypes.default.bool,
  onUpdateMainImage: _propTypes.default.func
};
var _default = FileCard;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/file-list/file-card.js
// module id = 734
// module chunks = 0